import { InscriptionFormType } from "@/types/edition";

export const mapInscriptionFormTypeToLabel = (
  formType: InscriptionFormType,
): string => {
  switch (formType) {
    case "SWORN_DECLARATION":
      return "Declaración Jurada de Participación";
    case "ENROLLMENT_FORM":
      return "Ficha de inscripción EGS";
    case "DECALOGUE":
      return "Decálogo de Empresa con Gestión Sostenible";
    case "REGULATION":
      return "Reglamento de Empresa con Gestión Sostenible";
    default:
      return formType;
  }
};
